import React, {useContext} from 'react';
import "./Back.scss"
import "./Adaptations.scss"
import { Link } from 'react-router-dom';
import { MainContext } from "../../contexts/MainContext";
import arrow from "../../static/img/Arrow 1.svg"

export default function Back({link}) {

  const {
    setSelectComActive,
    setSelectProActive,
    setSelectActive,
    setCommunitiesMarkers,
    setPropertiesMarkers
  } = useContext(MainContext);

  return (
    <>
      <Link
       className='back-btn' 
       to={link}
       onClick={() => {
        setSelectComActive(false);
        setSelectProActive(false);
        setSelectActive(false);
        setCommunitiesMarkers(true);
        setPropertiesMarkers(false);
       }}
      >
        <span>
          <img src={arrow} />
          back
        </span>
      </Link>
    </>
  );
};
